import type { RoutineIconId } from './routine-icon';

export type RoutineCategoryId =
  | 'general'
  | 'football'
  | 'recovery'
  | 'mobility'
  | 'strength'
  | 'prehab'
  | 'cardio'
  | 'conditioning'
  | 'core'
  | 'legs'
  | 'intensity';

export const routinePurposeDefinitions = [
  { id: 'warmup', icon: 'flame', legacyCategoryId: 'general' },
  { id: 'strength', icon: 'biceps-flexed', legacyCategoryId: 'strength' },
  { id: 'speed_power', icon: 'zap', legacyCategoryId: 'intensity' },
  { id: 'endurance', icon: 'footprints', legacyCategoryId: 'conditioning' },
  { id: 'mobility', icon: 'stretch-horizontal', legacyCategoryId: 'mobility' },
  { id: 'rehab', icon: 'shield', legacyCategoryId: 'prehab' },
  { id: 'recovery', icon: 'snowflake', legacyCategoryId: 'recovery' },
  { id: 'general', icon: 'sparkles', legacyCategoryId: 'general' },
] as const satisfies readonly {
  id: string;
  icon: RoutineIconId;
  legacyCategoryId: RoutineCategoryId;
}[];

export type RoutinePurposeId = (typeof routinePurposeDefinitions)[number]['id'];
export const defaultRoutinePurposeId: RoutinePurposeId = 'general';
export const routinePurposeIds = routinePurposeDefinitions.map(({ id }) => id);

export const routineFocusAreaIds = [
  'full_body',
  'upper_body',
  'lower_body',
  'core',
  'back_spine',
  'hips',
  'knees',
  'shoulders',
  'ankles_feet',
] as const;
export type RoutineFocusAreaId = (typeof routineFocusAreaIds)[number];

export function isRoutinePurposeId(value: unknown): value is RoutinePurposeId {
  return (
    typeof value === 'string' &&
    routinePurposeIds.includes(value as RoutinePurposeId)
  );
}

export function normalizeRoutinePurposeId(value: unknown): RoutinePurposeId {
  return isRoutinePurposeId(value) ? value : defaultRoutinePurposeId;
}

export function isRoutineFocusAreaId(
  value: unknown,
): value is RoutineFocusAreaId {
  return (
    typeof value === 'string' &&
    routineFocusAreaIds.includes(value as RoutineFocusAreaId)
  );
}

export function getRoutinePurposeIcon(purposeId: RoutinePurposeId) {
  return (
    routinePurposeDefinitions.find(({ id }) => id === purposeId)?.icon ??
    'sparkles'
  );
}

export function getRoutinePurposeLegacyCategoryId(
  purposeId: RoutinePurposeId,
): RoutineCategoryId {
  return (
    routinePurposeDefinitions.find(({ id }) => id === purposeId)
      ?.legacyCategoryId ?? 'general'
  );
}
